const bus = {
	listeners: {},
	addEventListener(event, callback) {
		if (!this.listeners[event]) {
			this.listeners[event] = []
		}
		this.listeners[event].push(callback)
		return this.listeners[event].indexOf(callback)
	},
	removeEventListener(event, ev) {
		const index = this.listeners[event]?.indexOf(ev)
		if (index !== undefined && index > -1) {
			this.listeners[event].splice(index, 1)
		}
	},
	removeAllEventListener(event) {
		if (event) {
			this.listeners[event] = []
		} else {
			this.listeners = {}
		}
	},
	emit(event, data) {
		if (this.listeners[event]) {
			for (const callback of this.listeners[event]) {
				setTimeout(() => {
					try { callback(data) } catch(e) { console.error('[BUS]: callback error:', e) }
				})
			}
		}
	}
}
window.$bus = bus;

export default bus;